<template>
  <div class="popUpMain">
    <div class="popUpLeft">
      <div class="popUpTop">
        <div class="popUpTopCtrlMain">
          <Input class="popUpTopInput" placeholder="Job No" :inputValue.sync="rotJobNo" :isDisabled="false"/>
          <div class="rotTableCtrlMain">
            <DateTime class="rotTableCtrl" title="Start" :value.sync="tableStartDate" :showTime="false"/>
            <DateTime class="rotTableCtrl" title="End" :value.sync="tableEndDate" :showTime="false"/>
            <button class="rotTableCtrlBtn" @click="rotBtnClick('refresh')"> Refresh </button> 
          </div>
        </div>
      </div>
      <div class="popUpBottom">
        <div class="rotTableMain"> 
          <Tabulator class="rotTable" tableTitle="List" tableID="rotNewTableMain" :tableData="data['rotJobList']" :selectedRow.sync="rotJobSlected" 
            multiSelect="1" :additionalColumn="rotNewTableAddCol" @cellButtonClick="cellButtonClick"/>
        </div>
      </div>
    </div>
    <div class="popUpRight">
      <button class="popUpTopCtrl" @click="rotBtnClick('next')" :disabled="rotJobNo ? false : true"> Next </button>
    </div>
    
    <Loader :isVisible="loadShow" :loadingText="loadText"/>
  </div>
</template>

<script>
/* eslint-disable */
import Tabulator from '@/components/Tabulator.vue';
import TabView from '@/components/TabView.vue';
import Input from '@/components/Input.vue';
import InputQuery from '@/components/InputQuery.vue';
import DateTime from '@/components/DateTimePicker.vue';
import Dropdown from '@/components/Dropdown.vue';
import Loader from '@/components/Loader.vue';

export default {
  components: {
    Tabulator, Input, InputQuery, DateTime, Dropdown, TabView, Loader
  },
  data: function() {
    return {
    }
  },
  props: {
    //-------- Main Props
    data: { type: Object, default: function () { return {} } },
    viewMode: { type: Boolean, default: false },
    errorFlag: { type: Boolean, default: false },

    //-------- Input Props
    rotJobNo: { type: String, default: '' },

    //-------- Table Props
    rotNewTableAddCol: { type: Array, default: function() { return [{ value: 'Select', type: 'button', index: '0' }]; }},
    rotJobSlected: { type: Array, default: function() { return []; }},
    tableStartDate: { type: Date, default: function() { return new Date; }},
    tableEndDate: { type: Date, default: function() { return new Date; }},
    
    //-------- Load Props
    loadShow: { type: Boolean, default: false },
    loadText: { type: String, default: 'Loading' },
  },
  mounted() {    
    this.$bus.$on('rotQueryJob', this.queryJob);
    this.$bus.$on('rotNewClear', this.clearData);
    // this.$set(this.data, 'rotJobList', [{ 'Status' : 'Please input date range and click refresh'}]);
  },
  methods: {
    queryJob: async function(jobno) {
      this.$nextTick(() => { this.rotJobNo = jobno; });
      this.$nextTick(() => { this.rotBtnClick('next') });
    },
    clearData: async function() {
      this.rotJobNo = '';
      this.$set(this.data, 'rotJobList', []);
      this.$set(this.data, 'rotJobListRaw', []);
      this.tableStartDate = new Date;
      this.tableEndDate = new Date;
    },
    rotBtnClick: async function(btn) {
      switch(btn) {
        case 'refresh':
          this.rotJobNo = '';
          this.data['popNewErrors'] = [];
          var start = this.formatDatetoString(this.tableStartDate).split(' ')[0];
          var end = this.formatDatetoString(this.tableEndDate).split(' ')[0];
          // console.log(start);
          // console.log(end);

          this.loadShow = true;

          //-------- ROT
          try {
            this.loadText = 'Getting Job List'; 
            var rotJobList = await this.$apiCallV2('/ROT/GetRotJob?startdate=' + start + '&enddate=' + end);
            // console.log(rotJobList);
            var rotJobListF = [];
            if (Array.isArray(rotJobList)) { 
              rotJobList.forEach((j) => {
                var DateA = [];
                Object.keys(j).forEach((k) => { if (k.search('Date') >= 0) { DateA.push(k); } });
                DateA.forEach((d) => { this.$set(j, d, j[d] ? this.formatDatetoString(j[d]) : ''); });
                rotJobListF.push(j); 
              });
            }
            this.$set(this.data, 'rotJobList', rotJobListF);
            // this.$set(this.data, 'rotJobListRaw', rotJobList['data']);
          } catch (e) { console.log(e); }

          this.loadShow = false; this.loadText = 'Loading'; 
          break;
        case 'next':
          this.data['popNewErrors'] = [];
          this.loadShow = true;

          try {
            this.loadText = 'Getting Job Details'; 
            this.$set(this.data, 'rotDetails', null);
            var rotValidation = await this.$apiCallV2('/ROT/ValidateJobsForROT?jobno=' + this.rotJobNo);
            // console.log('%cNew ROT Details', 'color:cyan;', rotValidation['data']);
            
            if (Array.isArray(rotValidation)) {
              if (rotValidation[0]['ErrMsg']) {
                rotValidation[0]['ErrMsg'].split('\n').forEach((msg) => {
                  this.data['popNewErrors'].push(msg);
                });
              } else {
                this.$set(this.data, 'rotDetails', rotValidation[0]);
                this.$bus.$emit('rotJobNew', 'next');
              }
            

              // console.log('%cError Check', 'color: green;', this.errorFlag);
            } else { 
              rotValidation.split('\n').forEach((m) => {
                if (m.trim()) { this.data['popNewErrors'].push(m); }
              });
            }
          } catch (e) { console.log(e); }

          this.loadShow = false; this.loadText = 'Loading'; 
          break;
      }
    },
    cellButtonClick: async function(btn, obj) {
      switch(btn) {
        case 'Select':
          // console.log(obj['Job #']);
          this.rotJobNo = obj['Job #'];
          break;
      }
    },


    //-------- Utility Methods
    formatDatetoString: function (date) {
      if (typeof date == 'string') {
        //console.log(date);
        var dateF = date.replace(/\/Date\(/g, '').replace(/\)\//g, '').replace(/\-/g, '-');
        try {
          var dateFF = new Date(dateF);
          if (!(dateFF.getTime() === dateFF.getTime())) { dateFF = new Date(parseInt(dateF)); }
        } catch (e) { /*console.log(e);*/ }
      } else {
        var dateFF = date;
      }
      
      var d = ((dateFF.getDate().toString().length < 2) ? '0' : '') + dateFF.getDate().toString();
      var m = (((dateFF.getMonth() + 1).toString().length < 2) ? '0' : '') + (dateFF.getMonth() + 1).toString();
      var y = dateFF.getFullYear();
      var hh = ((dateFF.getHours().toString().length < 2) ? '0' : '') + dateFF.getHours().toString();
      var mm = ((dateFF.getMinutes().toString().length < 2) ? '0' : '') + dateFF.getMinutes().toString();

      return `${y}-${m}-${d} ${hh}:${mm}`;
    },
    formatStringtoDate: function (date) {
      var dateF = date.replace(/ /g, '/').replace(/\:/g, '/');
      var dateFF = dateF.split('/');
      return new Date(dateFF[0], (parseInt(dateFF[1]) - 1).toString(), dateFF[2], dateFF[3], dateFF[4]);
    },
  },
  watch: {

  },
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

  .popUpMain {
    width: 100%;
    height: 100%;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .popUpLeft {
    width: auto;
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }

  .popUpRight {
    width: auto;
    height: 100%;
    padding: 0 3px 0 0;
    margin: 0 0 0 8px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
  }

  .popUpTop {
    width: 100%;
    height: auto;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .popUpTopCtrlMain {
    width: auto;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }

  .popUpTopCtrl {
    width: 86px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .popUpBottom {
    width: 100%;
    height: 100%;
    padding: 0 4px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }

  /* -- Table CSS -- */
  .rotTableMain {
    width: auto;
    height: 100%;
    flex: 1;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }

  .rotTable {
    width: auto;
    height: auto;
    position: absolute;
    top: 0px;
    bottom: 38px;
    left: 0px;
    right: 0px;
    background-color: #fff;
  }

  .rotTableCtrlMain {
    width: 100%;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: #fff;
  }

  .rotTableCtrl {
    width: 200px;
    height: 100%;
    margin: 0 4px 0 0;
  }

  .rotTableCtrlBtn {
    width: 80px;
    height: 100%;
    font-size: 12px;
    line-height: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

</style>